<template>
  <v-card
    rounded
    v-bind="$attrs"
    class="rounded-lg widget"
    :class="paddingTop"
    :color="color"
    :elevation="elevation"
  >
    <v-card-title v-if="title" :class="{ 'pl-md-0': fluid }">
      <span class="title primary--text">
        {{ $t(title) }}
      </span>
    </v-card-title>
    <v-card-text class="pa-0" :class="{ 'px-md-4': !fluid }">
      <template v-if="loading">
        <Loading :loading="loading" />
      </template>
      <template v-else>
        <slot name="content"></slot>
      </template>
      <v-card-actions>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import Loading from './Loading'
export default {
  name: 'VWidget',
  components: { Loading },
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'white'
    },
    dense: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: [Number, String],
      default: 0
    },
    paddingTop: {
      type: [String],
      default: 'pt-4'
    },
    fluid: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
.title
  font-size: 1.714rem !important
  font-weight: 600 !important
</style>
